import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Layout from "./components/Layout/Layout";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AccountPage from "./pages/AccountPage";
import AboutPage from "./pages/AboutPage";
import AboutWaterPage from "./pages/AboutWaterPage";
import BrochurePage from "./pages/BrochurePage";
import AdminPage from "./pages/AdminPage";
import MineralGuidePage from "./pages/MineralGuidePage";
import MineralQuizPage from "./pages/MineralQuizPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:id" element={<ProductDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/about-water" element={<AboutWaterPage />} />
                <Route path="/om-vann" element={<AboutWaterPage />} />
                <Route path="/brochure" element={<BrochurePage />} />
                <Route path="/brosjyre" element={<BrochurePage />} />
                <Route path="/mineral-guide" element={<MineralGuidePage />} />
                <Route path="/mineralvann-guide" element={<MineralGuidePage />} />
                <Route path="/mineral-quiz" element={<MineralQuizPage />} />
                <Route path="/mineralvann-quiz" element={<MineralQuizPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
